export default class NotYourTurn extends Error {
  constructor(message: string = 'Not your turn') {
    super(message);  // Pass message to the base Error class
    this.name = 'NotYourTurn'  // Assign a custom error name
  }
}
